export abstract class LoginService {
  abstract login(): Promise<boolean>;
  abstract showLoginDialog(): Promise<boolean>;
}
